import { Spinner } from 'components/Elements';
import { MainLayout } from 'components/Layout';
import { lazyImport } from 'utils/lazyImport';
import { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const { Dashboard } = lazyImport(() => import('features/misc'), 'Dashboard');
const { Profile } = lazyImport(() => import('features/users'), 'Profile');
const { OrdersRoutes } = lazyImport(() => import('features/orders'), 'OrdersRoutes');
const { SalesRoutes } = lazyImport(() => import('features/sales'), 'SalesRoutes');
const { PartnersRoutes } = lazyImport(() => import('features/partners'), 'PartnersRoutes');
const { AccountsRoutes } = lazyImport(() => import('features/users'), 'AccountsRoutes');
const { ModeratorsRoutes } = lazyImport(() => import('features/moderators'), 'ModeratorsRoutes');
const { HomePageRoutes } = lazyImport(() => import('features/pages/home'), 'HomePageRoutes');
const { AboutPageRoutes } = lazyImport(() => import('features/pages/about'), 'AboutPageRoutes');
const { BlogRoutes } = lazyImport(() => import('features/blog'), 'BlogRoutes');
const { ReviewsRoutes } = lazyImport(() => import('features/reviews'), 'ReviewsRoutes');
const { ProductsRoutes } = lazyImport(() => import('features/products'), 'ProductsRoutes');
const { ContactPageRoutes } = lazyImport(
  () => import('features/pages/contact'),
  'ContactPageRoutes'
);
const { ImpactPageRoutes } = lazyImport(() => import('features/pages/impact'), 'ImpactPageRoutes');
const { IntegrationsRoutes } = lazyImport(
  () => import('features/integrations'),
  'IntegrationsRoutes'
);
const { ServicesPageRoutes } = lazyImport(
  () => import('features/pages/services'),
  'ServicesPageRoutes'
);

const App = () => {
  return (
    <MainLayout>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            <Spinner size="xl" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </MainLayout>
  );
};

export const protectedRoutes = [
  {
    path: '/app',
    element: <App />,
    children: [
      { path: '/app/my-account', element: <Profile /> },
      { path: '/app/orders/*', element: <OrdersRoutes /> },
      { path: '/app/sales/*', element: <SalesRoutes /> },
      { path: '/app/users/*', element: <AccountsRoutes /> },
      { path: '/app/reviews/*', element: <ReviewsRoutes /> },
      { path: '/app/partners/*', element: <PartnersRoutes /> },
      { path: '/app/moderators/*', element: <ModeratorsRoutes /> },
      { path: '/app/home-page/*', element: <HomePageRoutes /> },
      { path: '/app/about-page/*', element: <AboutPageRoutes /> },
      { path: '/app/contact-page/*', element: <ContactPageRoutes /> },
      { path: '/app/impact-page/*', element: <ImpactPageRoutes /> },
      { path: '/app/services-page/*', element: <ServicesPageRoutes /> },
      { path: '/app/blog/*', element: <BlogRoutes /> },
      { path: '/app/products/*', element: <ProductsRoutes /> },
      { path: '/app/integrations/*', element: <IntegrationsRoutes /> },
      { path: '/app/', element: <Dashboard /> },
      { path: '*', element: <Navigate to="." /> },
    ],
  },
];
